import React from "react";
import DOMPurify from 'dompurify';
import moment from "moment/moment";
import {useLocation, useNavigate} from "react-router-dom";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Tag from "../../../../components/tag/Tag";
import styles from './Article.module.scss';

type ArticleCategory = {
    id: string | number;
    name: string;
    slug: string;
};

type ArticleData = {
    publishedAt: string;
    title: string;
    body: string;
    categories: ArticleCategory[];
};

type ArticleProps = {
    article?: ArticleData;
};

function Article({article}: ArticleProps) {

    const navigate = useNavigate();
    const location = useLocation();

    const onClickTag = (event: React.MouseEvent<HTMLDivElement>, slug: string) => {
        event.preventDefault();

        if (location.pathname !== '/blog') {
            navigate('/blog', {
                state: { category: slug }
            });
        }
    }

    if (!article){
        return null;
    }

    return (
        <div className={styles.article}>
            <Container>
                <div className={styles.articleContainer}>
                    <Row>
                    <Col xxl={8} className='p-0'>
                        <h5 className={styles.date}>
                            {moment(article.publishedAt).format('DD MMMM YYYY')}
                        </h5>
                        <h1 className={styles.title}>
                            {article.title}
                        </h1>
                        {article.categories.length > 0 && <div className={styles.tags}>
                            {article.categories.map(category => (
                                <Tag
                                    slug={category.slug}
                                    onClick={(e) => onClickTag(e, category.slug)}
                                    key={category.id}
                                >{category.name}</Tag>
                            ))}
                        </div>}
                        <div
                            className={styles.text}
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(article.body),
                            }}
                        >
                        </div>
                        <a href="/" className={styles.textLink}>Перейти на главную страницу</a>
                    </Col>
                </Row>
                </div>
            </Container>
        </div>
    );
}

export default Article;
